module.exports = __webpack_public_path__ + "static/media/triangle-warning-orange.b38f902b.svg";